// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_jr-0";